import React, { Fragment, useState, useEffect } from 'react';
import {Card} from 'rbx';
import '../../../styles/temporizador.scss';
 

function Temporizador (props){

    const calculateTimeLeft = () => {
        // FORMATA DATA
        function FormataStringData(data) {
            var dia  = data.split("/")[0];
            var mes  = data.split("/")[1];
            var ano  = data.split("/")[2].split(" ")[0];
            var hora = data.split(":")[0].split(" ")[1];
            var minuto = data.split(":")[1]
            var segundo = data.split(":")[2]
           
            return ano + '-' + ("0"+mes).slice(-2) + '-' + ("0"+dia).slice(-2) + ' ' + hora + ':' + minuto + ':' + segundo;
        }

        // PEGA A DATA PADRAO SP E CONVERTE PARA GERAR UMA NOVA DATA INDEPENDENTE DO HORARIO DO NAVEGADOR.
        let dataPadraoSP  = (new Date().toLocaleString("pt-BR", {timeZone: "America/Sao_Paulo"}))     
        let dataFormatada = FormataStringData(dataPadraoSP);
     
        const difference = +new Date(props.data) - +new Date(dataFormatada);
        //const difference = +new Date(props.data) - +new Date();

        if (difference > 0) {
            let dias    = Math.floor(difference / (1000 * 60 * 60 * 24));
            let hours   = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((difference % (1000 * 60)) / 1000);
           
            if(dias < 10 && dias > 1){
                dias = ' 0'+dias +' DIAS ';
            }
            if(dias > 9){
                dias = dias +' DIAS ';
            }
            
            if(dias === 1){
                dias = ' 0'+dias +' DIA ';
            }
            if(dias === '00' || dias === 0){
                dias = '';
            }
  
            if (hours < 10) {
                hours = '0'+hours;        
            }  
            if (minutes < 10) {
                minutes = '0'+minutes;        
            }       
            if (seconds < 10) {
               seconds = '0'+seconds;
            }   
            var temporizador = dias + hours+":"+minutes+":"+seconds; 
        
            
        }else{
            temporizador = 0;
        }
        
        return temporizador;
    }

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        setTimeout(() => {
          setTimeLeft(calculateTimeLeft());
        }, 1000);
        // Clear timeout if the component is unmounted
        
    },[Temporizador,timeLeft]);
    
    const timerComponents = [];

    Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
        return;
    }
   
    timerComponents.push(
        <span>
            {timeLeft[interval]}
        </span>
    );
    
    });

    return (
        <Fragment>
          <Card className="temporizador">
            <time>{props.status}: {timerComponents.length ? timerComponents : <span>00:00:00</span>}</time>
          </Card>
        </Fragment>
    )
}

export default Temporizador;
